import React from 'react';

interface YouTubeEmbedProps {
    videoId: string;
    title?: string;
    width?: number | string;
    height?: number | string;
}

const YouTubeEmbed: React.FC<YouTubeEmbedProps> = ({
    videoId,
    title,
    width = 560,
    height = 315,
}) => {
    const embedUrl = `https://www.youtube.com/embed/${videoId}?rel=0`;

    return (
        <iframe
            width="100%"
            height="100%"
            src={embedUrl}
            title={title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
        />
    );
};

export default YouTubeEmbed;